export const WEEKDAYSOBJECT = {
  ne: ['आईत', 'सोम', 'मंगल', 'बुध', 'बिही', 'शुक्र', 'शनि'],
  en: ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat']
};

export const englishToNepaliNumberMapper = {
  1: '१',
  2: '२',
  3: '३',
  4: '४',
  5: '५',
  6: '६',
  7: '७',
  8: '८',
  9: '९',
  10: '१०',
  11: '११',
  12: '१२',
  13: '१३',
  14: '१४',
  15: '१५',
  16: '१६',
  17: '१७',
  18: '१८',
  19: '१९',
  20: '२०',
  21: '२१',
  22: '२२',
  23: '२३',
  24: '२४',
  25: '२५',
  26: '२६',
  27: '२७',
  28: '२८',
  29: '२९',
  30: '३०',
  31: '३१',
  32: '३२'
};
